import { render, staticRenderFns } from "./declinioChartSideBar.vue?vue&type=template&id=e8a65a50"
import script from "./declinioChartSideBar.vue?vue&type=script&lang=js"
export * from "./declinioChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./declinioChartSideBar.vue?vue&type=style&index=0&id=e8a65a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports